<script setup lang="ts">
import type { LabelProps } from "./label.types";
import { useLabel } from "./useLabel";
import { labelTextClasses, labelDescriptionClasses } from "./label.styles";

defineOptions({ name: "ELabel" });

const props = defineProps<LabelProps>();

const { handleClick, classes } = useLabel({ props });
</script>

<template>
  <label part="base" :class="classes" @click="handleClick">
    <span part="text" :class="labelTextClasses">
      <slot />
    </span>
    <span v-if="props.description" part="description" :class="labelDescriptionClasses">
      {{ props.description }}
    </span>
  </label>
</template>
